import DatePicker from "react-datepicker";
import TextField from "./TextField";
import * as React from "react";
import styled from "styled-components";
import * as moment from "moment";

// This is just a wrapper component that styles the datepicker. See original documentation at: https://reactdatepicker.com/
// The custom input component has to be a class component because... reasons? This lib does custom components a weird way. See documentation, it breaks without it that way.
interface InputProps {
  value?: string;
  onClick?: () => void;
  disabled?: boolean;
}

class DatePickerInput extends React.Component<InputProps> {
  render() {
    return (
      <TextField
        value={this.props.value}
        onClick={this.props.onClick}
        readOnly
        disabled={this.props.disabled}
      />
    );
  }
}

const DatePickerWraper = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }
`;

// this whole thing is weird because the datepicker lib takes an already created React element so we have to deal with that
// better types should be added here later if possible
interface Props {
  [key: string]: any;
  onChange: any;
}

export default function CustomDatePicker({ onChange, ...props }: Props) {
  const input = <DatePickerInput disabled={props.disabled} /> as any;
  return (
    <DatePickerWraper>
      <DatePicker customInput={input} onChange={onChange} {...props} />
    </DatePickerWraper>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/core/DatePicker.tsx